

export enum ConnectorNames {
  Injected = "injected",
  WalletConnect = "walletconnect",
  BSC = "bsc",
  KAIKAS = "Kaikas",
  DECENT = "Decent",
  KLIP = "Klip",
}

export type Login = (connectorId: ConnectorNames) => void;

export interface Config {
  title: string;
  icon: any;
  // icon: FC<SvgProps>;
  connectorId: ConnectorNames;
}
